import * as React from "react";

import { AccessReportsWizardFormGroup } from "@app/access-reports/shared";

interface FormGroupNodeOverviewProps {
  formGroup: AccessReportsWizardFormGroup;
}

export const FormGroupNodeOverview: React.FC<React.PropsWithChildren<FormGroupNodeOverviewProps>> = (props: FormGroupNodeOverviewProps) => {
  return (
    <React.Fragment>
      <div className="row mb-3">
        <div className="col-6">
          <label
            className="label-s mb-0"
          >
            Title
          </label>
        </div>
        <div className="col-6">
          <p
            className="copy-text-default mb-0"
          >
            {props.formGroup.title}
          </p>
        </div>
      </div>

      <div className="row mb-3">
        <div className="col-6">
          <label
            className="label-s mb-0"
          >
            Elements
          </label>
        </div>
        <div className="col-6">
          {props.formGroup.elements.map((element, elementIndex) => (
            <p
              className="copy-text-default mb-0"
              key={elementIndex}
            >
              {element.elementId}
            </p>
          ))}
        </div>
      </div>

      <div className="row mb-3">
        <div className="col-6">
          <label
            className="label-s mb-0"
          >
            Disabled
          </label>
        </div>
        <div className="col-6">
          <p
            className="copy-text-default mb-0"
          >
            {props.formGroup.disabled ? "True" : "False"}
          </p>
        </div>
      </div>

      <div className="row mb-3">
        <div className="col-6">
          <label
            className="label-s mb-0"
          >
            Hidden
          </label>
        </div>
        <div className="col-6">
          <p
            className="copy-text-default mb-0"
          >
            {props.formGroup.hidden ? "True" : "False"}
          </p>
        </div>
      </div>

      {props.formGroup.groupPropertyId && (
        <React.Fragment>
          <div className="row mb-3">
            <div className="col-6">
              <label
                className="label-s mb-0"
              >
                Hidden Products
              </label>
            </div>
            <div className="col-6">
              {props.formGroup.hiddenProducts.length > 0 ? (
                props.formGroup.hiddenProducts.map((productId, productIdIndex) => (
                  <p
                    className="copy-text-default mb-0"
                    key={productIdIndex}
                  >
                    {productId}
                  </p>
                ))
              ) : (
                <p
                  className="copy-text-default mb-0"
                >
                  --
                </p>
              )}
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-6">
              <label
                className="label-s mb-0"
              >
                Disallowed Multiple Products
              </label>
            </div>
            <div className="col-6">
              {props.formGroup.disallowedMultipleProducts.length > 0 ? (
                props.formGroup.disallowedMultipleProducts.map((productId, productIdIndex) => (
                  <p
                    className="copy-text-default mb-0"
                    key={productIdIndex}
                  >
                    {productId}
                  </p>
                ))
              ) : (
                <p
                  className="copy-text-default mb-0"
                >
                  --
                </p>
              )}
            </div>
          </div>
        </React.Fragment>
      )}
    </React.Fragment>
  );
}
